import config from '@/config';
/**
 * return Environment
 * @param hostname
 * @returns {{domain: string, env: string}}
 * unit test
 */
export const env = hostname => {
  const splitted = hostname.split('.');
  const domain = splitted[1];
  const subDomain = splitted[0];

  const appSubDomain = config['appSubDomain'];

  if (domain === 'alphaus') {
    return {
      domain: domain,
      env: appSubDomain[domain][subDomain] ? appSubDomain[domain][subDomain] : 'dev',
    };
  }

  if (/localhost/.test(subDomain)) {
    return {
      domain: 'localhost',
      env: 'localhost',
    };
  }

  if (/prototype/.test(subDomain)) {
    return { domain: 'alphaus', env: 'dev' };
  }

  console.error(`Can't find 'env'. Hostname is wrong. hostname: ${hostname}`);
  return { domain: '', env: 'error' };
};

/**
 * return API URL
 * @param env
 * @param domainType
 * @param serviceType
 * @param port
 * @returns {String} | e.g. https://api.alphaus.cloud/m/ripple
 * unit test
 */
export const apiUrl = (env, domainType, serviceType, port) => {
  try {
    if (env === 'localhost') {
      port = config.apiPort;
      const apiUrl = config.apiUrl[domainType][serviceType]['localhost'];
      return apiUrl.replace('{port}', port);
    }
    if (env === 'prod' || env === 'next' || env === 'dev') {
      return config.apiUrl[domainType][serviceType][env];
    }

    throw 'Error';
  } catch (e) {
    console.error(
      `Got wrong params. env: ${env}, domainType: ${domainType}, serviceType: ${serviceType}`
    );
    throw new Error(
      `Got wrong params. env: ${env}, domainType: ${domainType}, serviceType: ${serviceType}`
    );
  }
};
